import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'badge-off', 'BadgeOff', [["path",{"d":"M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497"}],["path",{"d":"M3 3l18 18"}]]);